import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {MemberLoyaltyReportModel} from "./member-loyalty-report.model";

@Component({
    selector: "wbo-member-loyalty-report",
    templateUrl: "./member-loyalty-report.component.html",
    providers: [provideReportModel(MemberLoyaltyReportModel)]
})
export class MemberLoyaltyReportComponent extends AbstractReportPage {
    constructor(public model: MemberLoyaltyReportModel) {
        super();
    }

    get showSummaryOption(): boolean {
        return this.model.data.loyaltyType !== "REDEMPTION_LEGACY";
    }

    get showTops(): boolean {
        return this.showSummaryOption && this.model.data.summary;
    }

    get showEmployeeSelection(): boolean {
        return this.model.data.loyaltyType !== "REDEMPTION";
    }

    onSelectLoyaltyType(): void {
        if (this.model.data.loyaltyType === "REDEMPTION_LEGACY") {
            this.model.data.summary = true;
        }
    }
}
